import { Location } from '@core/Router/locations';
import { lazy } from 'react';

const DashboardPage = lazy(() =>
    import(/* webpackChunkName: "dashboard" */ '@dashboard/ui').then(m => ({ default: m.DashboardPage })),
);

export const dashboardLocations: Location[] = [
    {
        url: '/dashboard',
        Component: DashboardPage,
    },
];
